module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/scale-sub-list/scale-sub-list.component.scss
// module id = ./src/app/reports/scale-sub-list/scale-sub-list.component.scss
// module chunks = main